import React from "react";
import { motion } from "framer-motion";
import { useI18n } from "@/i18n/I18nContext";

const AVATARS = ["N", "B", "A", "J"];

const Star = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="var(--marigold)">
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01L12 2z" />
  </svg>
);

export default function Testimonials() {
  const { t } = useI18n();
  return (
    <section
      id="reviews"
      className="relative py-24 md:py-32"
      style={{ background: "var(--cream-2)" }}
      data-testid="testimonials-section"
    >
      <div className="container-x">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="chip-num mb-4">{t.testimonials.chip}</div>
            <h2 className="font-display font-medium text-[2.4rem] sm:text-[3rem] lg:text-[3.6rem] leading-[1] tracking-[-0.03em] text-[var(--ink)]">
              {t.testimonials.h2_a}{" "}
              <span className="font-editorial-italic text-[var(--marigold)]">
                {t.testimonials.h2_italic}
              </span>
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <div className="flex">
              {[0, 1, 2, 3, 4].map((i) => <Star key={i} />)}
            </div>
            <div className="text-sm text-[var(--muted)]">
              <span className="font-semibold text-[var(--ink)]">{t.testimonials.rating}</span> ·{" "}
              {t.testimonials.count}
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-4 md:gap-5">
          {t.testimonials.items.map((tt, i) => (
            <motion.blockquote
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{
                duration: 0.7,
                delay: (i % 2) * 0.1,
                ease: [0.2, 0.8, 0.2, 1],
              }}
              className={`rounded-[22px] p-7 md:p-8 relative ${
                i === 0
                  ? "bg-[var(--ink)] text-[var(--cream)] md:col-span-2"
                  : "bg-[var(--cream)] text-[var(--ink)] border border-[rgba(15,31,23,0.08)]"
              }`}
            >
              <div className="flex mb-4">
                {[0, 1, 2, 3, 4].map((s) => <Star key={s} />)}
              </div>
              <p
                className={`font-display font-medium leading-[1.25] tracking-tight ${
                  i === 0 ? "text-2xl md:text-3xl" : "text-xl md:text-[1.4rem]"
                }`}
              >
                &ldquo;{tt.quote}&rdquo;
              </p>
              <footer className="mt-6 flex items-center gap-3">
                <div
                  className={`w-10 h-10 rounded-full flex items-center justify-center font-display text-lg ${
                    i === 0
                      ? "bg-[var(--marigold)] text-[var(--ink)]"
                      : "bg-[var(--ink)] text-[var(--cream)]"
                  }`}
                >
                  {AVATARS[i]}
                </div>
                <div>
                  <div className="text-[14px] font-semibold">{tt.name}</div>
                  <div className="text-[12px] opacity-70">{tt.role}</div>
                </div>
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
